// @ts-nocheck
import useCurrentForm from "@store/Framework/Store/Foundation/Components/Form/FormHooks/useCurrentForm";
import { ReactNode, useEffect } from "react";

export default (id: string | number, error: ReactNode) => {
    const { setForm } = useCurrentForm();
    const inputId = String(id);

    useEffect(() => {
        setForm({
            id: inputId,
            error,
        });
    }, [error]);
};
